<template>
  <div ref="apply" style="padding-bottom: 20px;">
    <page-header title="New Partner Application" show-right-text/>
    <company-detail-info ref="companyDetailInfo" is-apply/>
    <select-country-and-region is-apply ref="selectCountryAndRegion"/>
    <admin-account is-apply ref="adminAccount"/>
    <partner-contract-info is-apply ref="partnerContractInfo"/>
    <sales-target-information is-apply ref="salesTargetInformation"/>
    <PurchaseSettingsInPartnerCenter is-apply ref="purchaseSettingsInPartnerCenter" />
    <support-document is-apply ref="supportDocument"/>
    <ruijieSalesInformation is-apply ref="ruijieSalesInformation"/>
    <footer-tips/>
    <footer-button is-apply @submit="openReconfirm" @cancel="handleBackPage"/>
    <reconfirm :visible.sync="reconfirmVisible" :loading="isLoading" @confirm="handleSubmit"/>
  </div>
</template>

<script>
import PageHeader from "../components/pageHeader.vue";
import CompanyDetailInfo from "../components/companyDetailInfo.vue";
import SelectCountryAndRegion from "../components/selectCountryAndRegion.vue";
import AdminAccount from "../components/adminAccount.vue";
import PartnerContractInfo from "../components/partnerContractInfo.vue";
import SalesTargetInformation from "../components/salesTargetInformation.vue";
import SupportDocument from "../components/supportDocument.vue";
import RuijieSalesInformation from "../components/ruijieSalesInformation.vue";
import PurchaseSettingsInPartnerCenter from "../components/purchaseSettingsInPartnerCenter.vue";
import {createPartner25} from "../../../../../api/international";
import Reconfirm from "../components/reconfirm.vue";
import FooterTips from "../components/footerTips.vue";
import FooterButton from "../components/footerButton.vue";

export default {
  name: "apply",
  components: {
    FooterButton,
    FooterTips,
    Reconfirm,
    RuijieSalesInformation,
    PurchaseSettingsInPartnerCenter,
    SupportDocument,
    SalesTargetInformation,
    PartnerContractInfo,
    AdminAccount,
    SelectCountryAndRegion,
    CompanyDetailInfo,
    PageHeader
  },
  data() {
    return {
      mainPagePadding: 0, // 首页原来的内边距
      reconfirmVisible: false,
      isLoading: false
    };
  },
  methods: {
    // 清除首页的padding
    resetMainPagePadding() {
      let pageDom = document.getElementsByClassName("mainpage")[0];
      this.mainPagePadding = pageDom.style.padding;
      pageDom.style.padding = 0;
      pageDom = null;
    },
    // 还原首页的padding
    restoreMainPagePadding() {
      let pageDom = document.getElementsByClassName("mainpage")[0];
      pageDom.style.padding = this.mainPagePadding;
      pageDom = null;
    },
    handleScrollToRef(type) {
      let contentDom = document.getElementsByClassName("mainpage")[0];
      contentDom.scrollTo({
        top: this.$refs[type].$el.offsetTop - 100,
      });
      contentDom = null;
    },
    // 获取组件的数据
    getFormData() {
      let companyDetailInfo = this.$refs["companyDetailInfo"].getFormData();
      let selectCountryAndRegion = this.$refs[
        "selectCountryAndRegion"
        ].getFormData();
      let adminAccount = this.$refs["adminAccount"].getFormData();
      let partnerContractInfo = this.$refs["partnerContractInfo"].getFormData();
      let purchaseSettingsInPartnerCenter = this.$refs["purchaseSettingsInPartnerCenter"].getFormData();
      let salesTargetInformation = this.$refs[
        "salesTargetInformation"
        ].getFormData();
      let ruijieSalesInformation = this.$refs[
        "ruijieSalesInformation"
        ].getFormData();
      if (!companyDetailInfo) {
        this.handleScrollToRef('companyDetailInfo')
        return false
      } else if (!selectCountryAndRegion) {
        this.handleScrollToRef('selectCountryAndRegion')
        return false
      } else if (!adminAccount) {
        this.handleScrollToRef('adminAccount')
        return false
      } else if (!partnerContractInfo) {
        this.handleScrollToRef('partnerContractInfo')
        return false
      }  else if (!purchaseSettingsInPartnerCenter) {
        this.handleScrollToRef('purchaseSettingsInPartnerCenter')
        return false
      } else if (!salesTargetInformation) {
        this.handleScrollToRef('salesTargetInformation')
        return false
      } else if (!ruijieSalesInformation) {
        this.handleScrollToRef('ruijieSalesInformation')
        return false
      }

      let supportDocument = this.$refs["supportDocument"].getFormData();
      // 跳转到未必填的地方
      if (!supportDocument) {
        this.handleScrollToRef('supportDocument')
        return false
      }

      return {
        partnerBaseInfo: {
          // 公司信息
          ...companyDetailInfo,
          // 选择国家信息
          ...selectCountryAndRegion,
          // 销售目标信息
          ...salesTargetInformation,
          // 渠道信息
          ...partnerContractInfo,
          ...purchaseSettingsInPartnerCenter,
          // 是否需要渠道确认
          isChannelConfirm: adminAccount.isChannelConfirm,
          // 支持文件
          ...supportDocument,
          // 销售信息
          ...ruijieSalesInformation,
          // 主账号
          masterAccount: adminAccount.email
        },
        linkMans: [
          // 主联系人
          {
            ...adminAccount,
            isChannelConfirm: void 0
          },
        ]
      };
    },
    // 打开二次确认弹窗
    openReconfirm() {
      let formData = this.getFormData();
      if (!formData) return;
      this.reconfirmVisible = true;
    },
    // 提交
    handleSubmit() {
      let formData = this.getFormData();
      if (formData) {
        this.isLoading = true
        createPartner25(formData)
          .then(res => {
            let {status, data} = res;
            if (status === "200") {
              this.$message.success("Application successful.");
              this.reconfirmVisible = false;
              this.$router.push(
                {
                  path: '/smb-sales-apply-success-2025',
                  query: {
                    documentId: data
                  }
                }
              );
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    // 返回上一页
    handleBackPage() {
      this.$router.back();
    }
  },
  mounted() {
    this.resetMainPagePadding();
  },
  beforeDestroy() {
    this.restoreMainPagePadding();
  }
};
</script>

<style scoped>
@import url("../index.css");
</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/SBG/apply/apply.vue